function decode(url: string) {
  return decodeURIComponent(url.toLowerCase())
}

/**
 * Helper function to normalize the URL and remove the leading @ sign.
 */
function decodeAndRemoveAtSign(url: string) {
  const decoded = decode(url)
  if (decoded.startsWith("@")) {
    return decoded.slice(1)
  }
  return decoded
}

/**
 *
 * Next revalidate tags based on a single post slug.
 */
export const postSlugTag = (slug: string) => {
  return `/post/${decode(slug)}`
}

/**
 *
 * When a comment is published, bust the comment cache.
 */
export const commentAddedTag = (postId: string) => {
  return `/comment/${decode(postId)}`
}

/**
 * Next revalidate tag based on blog update.
 */
export const blogUpdatedTag = (lowercaseUrl: string) => {
  const decoded = decodeAndRemoveAtSign(lowercaseUrl)

  return `/blog/${decoded}/public-changed`
}
